(function ($) {
  Drupal.behaviors.discoverNavbarFormatterV1 = {
    attach: function (context) {
      const self = this;
      const $modules = $('.js-discover-navbar', context).once();

      $modules.each(function () {
        const $module = $(this);

        self.getDom($module);
        self.removeSubmenus($module);
        self.addUrls($module);
      });
    },
    getDom: function ($module) {
      $module.nodes = {};
      $module.nodes.menu = $('.menu', $module).first();
      $module.nodes.submenus = $('.menu-container.depth-1', $module.nodes.menu);
      $module.nodes.menuItems = $module.nodes.menu.children(
        'li.menu-item-container',
      );
    },
    removeSubmenus: function ($module) {
      $module.nodes.submenus.remove();
    },
    addUrls: function ($module) {
      const observer = new MutationObserver(function (mutationsList, obs) {
        $module.addClass('active');
        obs.disconnect(); 
      });

      observer.observe($module[0], { 
        childList: true, 
        subtree: true 
      });

      $module.nodes.menuItems.each(function () {
        const $item = $(this);
        const itemLabel = $item.text().trim();
        const itemSlug = itemLabel
          .toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^a-z0-9\-_]/g, '');
        const itemHash = '#' + itemSlug;
        const $href = $('<a class="discover-menu-link"></a>')
          .attr('href', itemHash)
          .text(itemLabel);

        $item.empty().append($href);
      });
    },
  };
})(jQuery);
